/**
 * Bluemoon wrapper to initialize Pendo agent
 *
 * @packageDocumentation
 */
/* istanbul ignore file */
import { registerLibrary } from '@onviobr/app-information';
export { trackEvent, identify, isReady, flushNow, updateOptions, getVersion, getAccountId, getVisitorId, getCurrentUrl, findGuideById, findGuideByName, showGuideById, showGuideByName, toggleLauncher, removeLauncher, ready, guidesFailed, guidesLoaded, } from './tr-pendo/index';
export { trackAlert, initialize } from './blue-pendo.js';
registerLibrary({
    name: '@onviobr/app-info',
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    version: "6.2.0",
});
